import { s3WriteFile } from '../s3Utils';

export function updateData(fn, data) {
    s3WriteFile(fn, data);
}